/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCollection: {
  name: 'collection';
  data: string;
} = {
  name: 'collection',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5Zm14 14v-2h-4v2h4Zm-4 2h4v2h-4v-2Zm0-14h4v8h-4V4ZM5 8v12h3V8H5Zm3-2H5V4h3v2Zm2 1v13h3V4h-3v3Z" fill="currentColor"/></svg>`,
};
